// export const ARB_RPC = `https://arb1.arbitrum.io/rpc`;
export const ARB_RPC = `https://arbitrum-mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`;
export const ETH_RPC = `https://mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`;
export const AVAX_RPC = `https://avalanche-mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`;
export const POLYGON_RPC = `https://polygon-mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`;
